export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.5 3.5a1 1 0 011 1v15a1 1 0 01-1 1h-17a1 1 0 01-1-1v-15a1 1 0 011-1h17zm-16 15h15v-13h-15v13z\" fill=\"#7B61FF\"/><path d=\"M15.994 7.6l-2.832 4.224 2.964 4.392H13.87l-1.908-2.892-1.908 2.892H7.87l2.952-4.392L7.99 7.6h2.256l1.776 2.724L13.798 7.6h2.196z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};